export const periodTypes = {
  TODAY: 'today',
  WEEK: 'week',
  PERIOD: 'period'
}